<template>
    <div class="btn-group" :class="{'is-vertical': props.vertical, 'btn-group--text': props.text}">
        <slot/>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
	vertical?: boolean,

	// Whether the children buttons have a text style which affects the group style
	text?: boolean,
}>();
</script>

<style>
/*********************
  Inputs
**********************/
.btn-group {
  display: flex;
}
.btn-group:not(.is-vertical) + .btn-group {
  margin-left: 8px;
}
.btn-group:not(.is-vertical) > *:not(:first-child).btn, .btn-group:not(.is-vertical) > *:not(:first-child) .btn, .btn-group:not(.is-vertical) > *:not(:first-child).form-input > .form-input__content {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.btn-group:not(.is-vertical) > *:not(:last-child).btn, .btn-group:not(.is-vertical) > *:not(:last-child) .btn, .btn-group:not(.is-vertical) > *:not(:last-child).form-input > .form-input__content {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.btn-group:not(.is-vertical).btn-group--text > *.btn, .btn-group:not(.is-vertical).btn-group--text > * .btn {
  border: none;
}
.btn-group:not(.is-vertical).btn-group--text > *:not(:last-child).btn:after, .btn-group:not(.is-vertical).btn-group--text > *:not(:last-child) .btn:after {
  content: "";
  height: 40%;
  width: 1px;
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #e6ecf5;
}
.btn-group:not(.is-vertical):not(.btn-group--text) > *:not(:first-child).btn, .btn-group:not(.is-vertical):not(.btn-group--text) > *:not(:first-child) .btn {
  border-left: none;
}
.btn-group:not(.is-vertical):not(.btn-group--text) > *:not(:last-child).btn, .btn-group:not(.is-vertical):not(.btn-group--text) > *:not(:last-child) .btn {
  border-right-color: #e6ecf5;
}
.btn-group.is-vertical {
  flex-direction: column;
}
.btn-group.is-vertical + .btn-group {
  margin-top: 8px;
}
.btn-group.is-vertical > *:not(:first-child).btn, .btn-group.is-vertical > *:not(:first-child) .btn {
  border-top-right-radius: 0 !important;
  border-top-left-radius: 0 !important;
}
.btn-group.is-vertical > *:not(:last-child).btn, .btn-group.is-vertical > *:not(:last-child) .btn {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-color: #e6ecf5;
}
</style>